import { AuthLayout } from '@/components/layout/auth-layout'
import { Button } from '@/components/primitives/button'
import { AuthBrandHeader } from '@/features/auth/components/brand-header'
import { LanguageSegmentedControl } from '@/features/auth/components/language-segmented-control'
import { MobileOAuthAuthorizationResumePage } from '@/features/auth/mobile/mobile-oauth-authorization-resume-page'
import { useOAuthAuthorizationResumePage } from '@/features/auth/oauth/use-oauth-authorization-resume-page'
import { setAppLanguage } from '@/i18n/i18n'
import { clearPortalSession } from '@/lib/auth/portal-session'
import { useMediaQuery } from '@/lib/use-media-query'

export function OAuthAuthorizationResumePage() {
  const isMobile = useMediaQuery('(max-width: 767px)')
  if (isMobile) return <MobileOAuthAuthorizationResumePage />
  return <DesktopOAuthAuthorizationResumePage />
}

function DesktopOAuthAuthorizationResumePage() {
  const { failed, language, t } = useOAuthAuthorizationResumePage()

  return (
    <AuthLayout
      actions={
        <LanguageSegmentedControl
          language={language}
          onLanguageChange={(nextLanguage) => void setAppLanguage(nextLanguage)}
          t={t}
        />
      }
      cardClassName="min-h-[420px]"
      portal="user"
    >
      <div className="grid min-h-[300px] content-center gap-6">
        <AuthBrandHeader title={t('user.title')} />
        {failed ? (
          <div className="grid gap-5">
            <div
              className="rounded-lg bg-red-50 px-4 py-3 text-sm leading-6 text-[var(--color-danger)]"
              role="alert"
            >
              <p className="font-semibold">{t('oauthAuthorization.errorTitle')}</p>
              <p className="mt-1">{t('oauthAuthorization.errorDescription')}</p>
            </div>
            <Button
              className="h-[42px] rounded-lg text-base font-bold"
              onClick={() => {
                clearPortalSession('user')
                window.location.assign('/login?resume=oauth_authorization')
              }}
              type="button"
            >
              {t('oauthAuthorization.backToLogin')}
            </Button>
          </div>
        ) : (
          <div className="grid justify-items-center gap-4 text-center">
            <div className="size-10 animate-spin rounded-full border-2 border-[rgba(25,91,255,0.16)] border-t-[var(--color-primary)]" />
            <p className="text-sm leading-6 text-[var(--color-text-muted)]">
              {t('oauthAuthorization.processing')}
            </p>
          </div>
        )}
      </div>
    </AuthLayout>
  )
}
